import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* global L */
// Constant key
var ENTER_KEY = 13;
var ESCAPE_KEY = 27;

var SearchElement = /*#__PURE__*/function () {
  /**
   * Define if search has error
   *
   * @property {Boolean} hasError
   */

  /**
   * Define if search is active
   *
   * @property {Boolean} isActive
   */

  /**
   * List of elements on SearchElement
   *
   * @property {Objects} elements
   */

  /**
   * SearchElement Constructor
   *
   * @param {Function} handleSubmit Callback on submit
   * @param {String} inputLabel Label for input
   * @param {classNames} classNames Objects of class names for elements
   */
  function SearchElement() {
    var _this = this;

    var handleSubmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var inputLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'search';
    var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, SearchElement);

    _defineProperty(this, "hasError", false);

    _defineProperty(this, "isActive", false);

    _defineProperty(this, "elements", {
      container: null,
      form: null,
      input: null,
      resetButton: null
    });

    var container = L.DomUtil.create('div', ['tocoordinates', classNames.container].join(' '));
    var form = L.DomUtil.create('form', ['', classNames.form].join(' '), container);
    var input = L.DomUtil.create('input', ['glass', classNames.input].join(' '), form);

    if (!(input instanceof HTMLInputElement)) {
      throw new Error("".concat(classNames.input, " is not an input"));
    }

    input.type = 'text';
    input.placeholder = inputLabel;
    var resetButton = L.DomUtil.create('a', classNames.resetButton, form);
    resetButton.innerHTML = 'X';
    L.DomEvent.on(resetButton, 'click', this.clearInput, this); // When focus or blur active form

    L.DomEvent.on(input, 'focus blur', function () {
      L.DomUtil.addClass(_this.elements.form, 'active');
    });
    L.DomEvent.on(input, 'keydown', this.onKeyDown, this);
    this.elements = {
      container: container,
      form: form,
      input: input,
      resetButton: resetButton
    };
    this.handleSubmit = handleSubmit;
  }
  /**
   * Call on submit for call the callback this.handleSubmit
   * Called when enter is pressed
   *
   * @param {KeyboardEvent} event Event of keyboard
   */


  _createClass(SearchElement, [{
    key: "onSubmit",
    value: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      this.resetError();
      var response = this.handleSubmit(this.elements.input.value);

      if (response === false) {
        this.setError();
      }
    }
    /**
     * When key is pressed
     *
     * @param {KeyboardEvent} event Event of keyboard
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var container = this.elements.container;

      if (event.keyCode === ENTER_KEY) {
        this.onSubmit(event);
      } else if (event.keyCode === ESCAPE_KEY) {
        L.DomUtil.removeClass(container, 'active');
        this.clearInput();
        document.body.focus();
        document.body.blur();
      } else if (this.hasError) {
        this.resetError();
      }
    }
    /**
     * Shortcut to set active status
     */

  }, {
    key: "setActive",
    value: function setActive() {
      var _this$elements = this.elements,
          container = _this$elements.container,
          input = _this$elements.input;
      this.isActive = true;
      L.DomUtil.addClass(container, 'active');
      input.focus();
    }
    /**
     * Shortcut to reset active status
     */

  }, {
    key: "resetActive",
    value: function resetActive() {
      this.isActive = false;
      this.clearInput();
      L.DomUtil.removeClass(this.elements.container, 'active');
    }
    /**
     * Shortcut to set error status
     */

  }, {
    key: "setError",
    value: function setError() {
      this.hasError = true;
      L.DomUtil.addClass(this.elements.input, 'error');
    }
    /**
     * Shortcut to reset error status
     */

  }, {
    key: "resetError",
    value: function resetError() {
      this.hasError = false;
      L.DomUtil.removeClass(this.elements.input, 'error');
    }
    /**
     * Shortcut to clear input and remove error class
     */

  }, {
    key: "clearInput",
    value: function clearInput() {
      var input = this.elements.input;
      input.value = '';
      L.DomUtil.removeClass(input, 'error');
    }
  }]);

  return SearchElement;
}();

export { SearchElement as default };